module.exports = __webpack_public_path__ + "static/media/loading_spinner.db07ca5b.svg";